/**
 *
 * @param {*} state
 * @returns {object} Flat list of components
 */
export const componentDefinition = (state) => {
  let componentDefinition = new Object(null);

  for (let category in state.components) {
    for (let component in state.components[category].components) {
      componentDefinition[component] =
        state.components[category].components[component];
    }
  }
  return componentDefinition;
};

/**
 *
 * @param {*} state
 * @returns {object} Flat list of templates
 */
export const templates = (state) => {
  //pure object
  let templates = new Object(null);
  state.templates.forEach((templatesCategory) => {
    templatesCategory.design?.forEach((design) => {
      templates[design.design_id] = design;
    });
  });
  return templates;
};

/**
 *
 * @param {*} state
 * @returns frame index
 */
export const getCurrentFrame = (state) => {
  return state.currentFrame;
};

/**
 *
 * @param {*} state
 * @returns all animation frames
 */
export const getFrames = (state) => {
  return state.frames;
};

/**
 *
 * @param {*} state
 * @returns all events
 */
export const getEvents = (state) => {
  return state.events.triggers;
};

/**
 * 
 * @param {*} state
 * @returns all tags
 */
export const getTags = (state) => {
  return state.tags;
};

/**
 *
 * @param {*} state
 * @returns all custom methods
 */
export const getCustomMethods = (state) => {
  return state.events.methods;
};

/**
 *
 * @param {*} state
 * @returns current creative name
 */
export const getCreativeName = (state) => {
  return state.activeCreativeName;
};

/**
 *
 * @param {*} state
 * @returns current creative id
 */
export const getCreativeId = (state) => {
  return state.activeCreativeId;
};

/**
 *
 * @param {*} state
 * @returns creative saved
 */
export const isDraftSaved = (state) => {
  return state.isDraftSaved;
};


/**
 *
 * @param {*} state
 * @returns creative saved
 */
export const templateCache = (state) => {
  return state.templateCache;
};

/**
 *
 * @param {*} state
 * @returns isPerview
 */
export const isPreview = (state) => {
  return state.isPreview;
};

/**
 *
 * @param {*} state
 * @returns thumnailUrl
 */
export const thumbnailUrl = (state) => {
  return state.thumbnailUrl;
};

/**
 *
 * @param {*} state
 * @returns flat list of permissions
 *
 */
export const permissions = (state) => {
  const permissions = {
    own: {},
    org: {},
  };

  state.currentUser.permissionNames.forEach((permissionName) => {
    const permission = permissionName.split(".");
    //value will be either 'own' or 'org'
    const actor = permission[0];
    const subject = permission[1];
    const action = permission[2];

    if (Array.isArray(permissions[actor][subject])) {
      permissions[actor][subject].push(action);
    } else {
      permissions[actor][subject] = [action];
    }
  });

  return permissions;
};

/**
 *
 * @param {*} state
 * @param {*} getters
 * @returns if user has permission to perform action on orgaization
 */
export const hasOrgPermission = (state, getters) => (subject, permission) => {
  return Boolean(getters.permissions?.org[subject]?.includes(permission));
};
/**
 *
 * @param {*} state
 * @param {*} getters
 * @returns if user has permission to perform action on own
 */
export const hasOwnPermission = (state, getters) => (subject, permission) => {
  return getters.permissions?.own[subject]?.includes(permission);
};

// not working added in index getters
export const loadedFonts = (state) => {
  if (!(state.loadedFonts instanceof Set)) {
    state.loadedFonts = new Set();
  }
  return state.loadedFonts;
};

export const getCurrentUser = (state) => {
  return state.currentUser;
};

export const getDraftSaveStatus = (state) => {
  return state.isSaved;
};

export const getCurrentPageId = (state) => {
  return state.frames[state.currentFrame].id;
};

export const getActiveCreativeVersion = (state) => {
  return state.activeCreativeVersion;
};

export const getTimelineEvents = (state) => {
  return state.events.timelineEvents;
};

export const getTimedEvents = (state) => {
  return state.timedEvents;
};
export const getComponentExitUrl = (state) => {
  return state.componentExitUrl;
};
